import { internalDateFormat } from '@hivebrite/design-system/Inputs';

import { Date } from 'hb-react/shared/components/formik/components/inputs';
import dayjs from 'hb-react/shared/utils/dayjs/dayjs';

export const ExpireDate = () => (
  <Date
    label={s__('JobForm|Expiration date')}
    minDate={dayjs().startOf('day').format(internalDateFormat.dayjs)}
    name="expires_at"
    placeholder={s__('JobForm|Expiration date')}
    clearable={false}
    validate={{
      required: true,
    }}
  />
);
